import React, { useEffect } from 'react'
import { useParams, useHistory } from 'react-router-dom'

const PriveRedirect = () => {
  const { slug } = useParams()
  // console.log('slug ', slug)
  const history = useHistory()

  useEffect(() => {
    const slugParts = slug.split('-')
    const priveId = slugParts[slugParts.length - 1]
    // console.log('slugParts ', slugParts)
    // console.log('priveId ', priveId)
    history.replace(`/auth/register?priveId=${priveId}`)
  }, [slug, history])

  return null
}

export default PriveRedirect
